import { render } from "./RoundImage.vue?vue&type=template&id=428dcb74"
import script from "./RoundImage.vue?vue&type=script&lang=js"
export * from "./RoundImage.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/provider-frontend/provider-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__